import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, scroll, getValFromLS, isFieldError } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Select from "../components/Select";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Nav from "./Nav";

const Asset = () => {
	const [user, setUser] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardAssetInit`);
			const params = {
				q: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setNames({ ...json });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardAsset`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/dashboard/${user.id}`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Digital Asset Contact" />

						<p>
							Use this form to make any updates to your designated digital asset
							(ticketing) contact.
						</p>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Digital Asset (Ticketing) Contact Information
							</h4>

							<div className="form-group">
								<Select
									name="prefix"
									label="Prefix"
									reqd={true}
									value={names.prefix || ""}
									options={[
										{ id: "", name: "--" },
										{ id: "Mr.", name: "Mr." },
										{ id: "Mrs.", name: "Mrs." },
										{ id: "Ms.", name: "Ms." },
										{ id: "Dr.", name: "Dr." },
										{ id: "Other", name: "Other" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "prefix")}
								/>

								<Input
									name="title"
									label="Title"
									reqd={true}
									value={names.title || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="fname"
									label="First Name"
									reqd={true}
									value={names.fname || ""}
									autocomplete="given-name"
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="lname"
									label="Last Name"
									reqd={true}
									value={names.lname || ""}
									autocomplete="family-name"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group ">
								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email || ""}
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="phone"
									label="Phone"
									reqd={true}
									value={names.phone || ""}
									autocomplete="tel"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Update Asset Contact Info" />
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={7} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Asset;
